import { render, staticRenderFns } from "./ErDetails.vue?vue&type=template&id=7e8b26ed&scoped=true&"
import script from "./ErDetails.vue?vue&type=script&lang=js&"
export * from "./ErDetails.vue?vue&type=script&lang=js&"
import style0 from "./ErDetails.vue?vue&type=style&index=0&id=7e8b26ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8b26ed",
  null
  
)

export default component.exports